<ng-container *ngIf="isPreCount">
  Votes for {{districtName}} election are still being counted. The candidate leading in the count will be announced here once preliminary results are reported from voting centres in the district.
</ng-container>
<ng-container *ngIf="isCounting">
  Votes for {{districtName}} District are still being counted. The candidate leading in the count is: {{candidateName}}, {{candidateAffiliation}}.
</ng-container>
<ng-container *ngIf="isFinal">
  The winner of the election in {{districtName}} District is: {{candidateName}}, {{candidateAffiliation}}.
</ng-container>

